import React, {Component} from 'react';
import './downloadList.scss';

class DownloadList extends Component {
  constructor(props) {
    super(props);
    this.state = {checkedCount: 0};
  }

  onCheckBoxClicked = ({name, checked}) => {
    this.setState((prev) => ({
      checkedCount: checked ? prev.checkedCount + 1 : prev.checkedCount - 1
    }));
  };

  render() {
    const {chartTitle, fileUrls, downloadEndpoint, epoch} = this.props;
    const {checkedCount} = this.state;

    return (<div class="download-wrapper">
        <h3>{chartTitle}</h3>
        {(fileUrls.length > 0) ? (<form action={downloadEndpoint}>
          <table>
            <tbody>
            {fileUrls.map((fileUrl, index) => {
              return (<tr key={fileUrl.id}>
                <td>
                  <input
                    name="fileIds[]"
                    type="checkbox"
                    id={fileUrl.id}
                    value={fileUrl.id}
                    onChange={(event) => this.onCheckBoxClicked(event.target)}
                  />
                </td>
                <td>
                  <label>{fileUrl.label}</label>
                </td>
                <td>{fileUrl.size}</td>
              </tr>)
                })}
                <tr>
                  <td colSpan={3}>
                <p>
                  Der Datensatz steht unter der Lizenz: Creative Commons Namensnennung 4.0 International (CC BY 4.0). Die Namensnennung des Bayerischen Landesamtes für Umwelt als Rechteinhaber hat in folgender Weise zu erfolgen: Datenquelle: Bayerisches Landesamt für Umwelt, <a href="https://www.lfu.bayern.de" target="_blank">www.lfu.bayern.de</a>. Bitte beachten Sie ebenfalls die ausführlichen <a href="/impressum">Nutzungsbedingungen</a> und die <a href="/datenschutz">Datenschutzerklärung</a>.
                </p>
              </td>
            </tr>
            <tr>
              <td colSpan={3}>
                <input type="hidden" value={epoch} name="epoch"/>
                <button  className="download-button" type="submit" disabled={checkedCount < 1}>Download</button>
              </td>
            </tr>
            </tbody>
          </table>
        </form>) : (
          <p style={{textAlign: 'center'}}>Zu dieser Region liegen leider noch keine Daten vor. <br/> Kommen Sie
            bitte
            zu einem späteren Zeitpunkt
            wieder.</p>)}
      </div>

    )
  }
}

DownloadList.propTypes = {};

DownloadList.defaultProps = {};

export default DownloadList;
